export const pages = `
  data {
  id
    attributes {
      slug
      title
      displaytitle
      description
      booking
      media {
        data {
          attributes {
            width
            height
            caption
            mime
            url
            hash
            ext
          }
        }
      }
    }
  }
`;